import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Spacing } from '../../styles';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';
import { BottomBar } from './bottomBar';
import { RestartButton } from './restartButton';
import { BottomComponentBarBaseProps } from './types';

export const BottomComponentBar = (props: BottomComponentBarBaseProps) => {
  const isWeb = Platform.OS === 'web';
  const left = props.left || props.backButton;
  const right = props.right ? (
    props.right
  ) : props.onRightPress ? (
    <RestartButton
      onPress={props.onRightPress}
      disabled={props.rightPressDisabled}
    />
  ) : undefined;

  const centerBlock =
    props.additionalHeaderBlock ||
    (props.onSave ? (
      <SaveButton
        onPress={() => props.onSave?.()}
        disabled={props.rightPressDisabled}
        label={props.saveLabel}
        fontSize={!isWeb ? 14 : undefined}
        style={[
          styles.baseButton,
          props.rightPressDisabled
            ? styles.addButtonDisabled
            : styles.addButtonEnabled,
        ]}
      />
    ) : undefined);

  return (
    <BottomBar
      style={props.style}
      left={left}
      right={right}
      additionalHeaderBlock={centerBlock}
    />
  );
};

type SaveButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  isLoading?: boolean;
  activeTextColor?: string;
  fontSize?: number;
};

const SaveButton: FC<SaveButtonProps> = (props: SaveButtonProps) => {
  const { t } = useTranslation();

  const state = props.disabled ? 'warning' : 'default';
  return (
    <Button
      onPress={props.onPress}
      style={styles.saveButtonContainer}
      state={state}
      disabled={props.disabled}
    >
      {t('topNav.save')}
    </Button>
  );
};

const styles = StyleSheet.create({
  baseButton: {
    width: 56,
    height: 56,
    maxHeight: 56,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 8,
    marginRight: Spacing.baseMargin.base,
  },
  addButtonDisabled: {
    backgroundColor: Colors.grayDivider,
  },
  addButtonEnabled: {
    backgroundColor: Colors.primary,
  },
  saveButtonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
});
